import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {Location} from '@angular/common';

@Component({
  selector: 'app-app-not-found',
  standalone: true,
  imports: [],
  templateUrl: './app-not-found.component.html',
  styleUrl: './app-not-found.component.scss'
})
export class AppNotFoundComponent {

  constructor(private router: Router,
              private location: Location) {
  }


  goToHome(): void {
    this.router.navigate(['/']).then();
  }


  goBack(): void {
    this.location.back();
  }

}
